import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-nowrap w-full justify-center items-center" }
const _hoisted_2 = ["disabled", "onClick"]
const _hoisted_3 = ["id", "name"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "sr-only",
  "aria-hidden": "true",
  tabindex: "-1"
}, " OK ", -1)
const _hoisted_5 = ["disabled", "onClick"]

import { isInteger, throttle } from 'lodash';
import { useVModel } from '@vueuse/core/';
import { computed, ComputedRef, ref, Ref, toRef, watch, withDefaults } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'QuantityField',
  props: {
    id: { default: Math.random() },
    modelValue: { default: 0 },
    multiplier: { default: 1 },
    max: { default: undefined },
    pending: { type: Boolean, default: false }
  },
  emits: ['update:modelValue', 'change'],
  setup(__props: any, { emit }) {

const props = __props as { id: string | number, modelValue: number, multiplier: number, max: number, pending: boolean }




const externalQuantity: Ref<number> = useVModel(props, 'modelValue', emit);
const internalQuantity: Ref<number> = ref(0);
const multiplier: Ref<number> = toRef(props, 'multiplier');

const isMinQuantity: ComputedRef<boolean> = computed(() => internalQuantity.value <= multiplier.value);
const isMaxQuantity: ComputedRef<boolean> = computed(() => props.max !== undefined && internalQuantity.value + multiplier.value > props.max);

watch(externalQuantity, quantity => {
    if (quantity !== internalQuantity.value) {
        internalQuantity.value = quantity;
    }
}, { immediate: true });

const decreaseQuantity = (): void => {
    if (props.pending || isMinQuantity.value) { return; }
    const delta = -multiplier.value;
    internalQuantity.value += delta;
    updateExternal(delta);
};

const setQuantity = throttle((): void => {
    if (props.pending) {
        return;
    }
    if (!isInteger(internalQuantity.value) || internalQuantity.value < 1) {
        internalQuantity.value = externalQuantity.value;
        return;
    }
    if (props.max !== undefined && internalQuantity.value > props.max) {
        internalQuantity.value = props.max;
    }
    const delta = internalQuantity.value - externalQuantity.value;
    updateExternal(delta);
}, 100, { leading: false });

const increaseQuantity = (): void => {
    if (props.pending || isMaxQuantity.value) {
        return;
    }
    const delta = multiplier.value;
    internalQuantity.value += delta;
    updateExternal(delta);
};

const updateExternal = (delta: number): void => {
    externalQuantity.value = internalQuantity.value;
    emit('change', { quantity: internalQuantity.value, delta });
};

return (_ctx: any,_cache: any) => {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["p-5 pt-3 transition-opacity duration-300 ease-out", {'opacity-35 cursor-default': _unref(isMinQuantity)}]),
      disabled: _unref(isMinQuantity),
      onClick: _withModifiers(decreaseQuantity, ["prevent"])
    }, [
      _createVNode(_component_c_icon, {
        name: "icon-minus-medium",
        class: "w-12"
      })
    ], 10, _hoisted_2),
    _createElementVNode("form", {
      class: "flex-1 max-w-40",
      novalidate: "",
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_unref(setQuantity) && _unref(setQuantity)(...args)), ["prevent"]))
    }, [
      _withDirectives(_createElementVNode("input", {
        id: `line-item-quantity-id-${__props.id}`,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalQuantity).value = $event)),
        type: "number",
        name: `line-item-quantity-${__props.id}`,
        pattern: "\\d*",
        class: "w-full border border-transparent py-5 text-center",
        onChange: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_unref(setQuantity) && _unref(setQuantity)(...args)), ["prevent"]))
      }, null, 40, _hoisted_3), [
        [_vModelText, internalQuantity.value]
      ]),
      _hoisted_4
    ], 32),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["p-5 pt-3", {'opacity-35 cursor-default': _unref(isMaxQuantity)}]),
      disabled: _unref(isMaxQuantity),
      onClick: _withModifiers(increaseQuantity, ["prevent"])
    }, [
      _createVNode(_component_c_icon, {
        name: "icon-plus-medium",
        class: "w-12"
      })
    ], 10, _hoisted_5)
  ]))
}
}

})